<div [@toastAppearLeave]="toasterService.toasts.length" aria-live="polite" aria-atomic="true" class="toasts-container">
  <div *ngFor="let toast of toasterService.toasts" class="toast fade show me-2 toast-component" role="alert" aria-live="assertive" aria-atomic="true">
    <app-toast [toast]="toast"></app-toast>
  </div>
</div>